export default ['originalEventModel', 'mdn', 'Email'];
